"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("./utils/createSvgIcon"));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/_react.default.createElement("path", {
  d: "M19.76 10h-4.67a.23.23 0 0 1-.18-.08.26.26 0 0 1-.07-.19l.62-6.19a3.22 3.22 0 1 0-6.4 0l.62 6.19a.22.22 0 0 1-.06.19.25.25 0 0 1-.18.08H4.76a2.51 2.51 0 0 0-2.5 2.5v1a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-1a2.5 2.5 0 0 0-2.5-2.5Zm-6.5-6.25a1 1 0 1 1-1-1 1 1 0 0 1 1 1Zm8 12.75a.5.5 0 0 0-.5-.5h-17a.5.5 0 0 0-.5.5v1.3a8.62 8.62 0 0 1-1.36 4.66A1 1 0 0 0 2.74 24h1.49a3.48 3.48 0 0 0 2.91-1.56c.22-.32.44-.66.66-1a.26.26 0 0 1 .28-.11.26.26 0 0 1 .18.24V23a1 1 0 0 0 1 1h4.25a.25.25 0 0 0 .25-.25v-2.5a.5.5 0 0 1 1 0v2.5A.25.25 0 0 0 15 24h2a.25.25 0 0 0 .25-.25V19.5a.5.5 0 0 1 1 0v4.25a.25.25 0 0 0 .25.25h1.75a1 1 0 0 0 1-1Z"
}), 'ColorBrush');

exports.default = _default;